import React, { useState, useEffect } from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Divider, Button, Avatar, IconButton, Drawer } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventIcon from '@mui/icons-material/Event';
import PeopleIcon from '@mui/icons-material/People';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const menuItems = [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/admin-panel' },
    { label: 'Events', icon: <EventIcon />, path: '/admin-panel/events' },
];

// MOCK utilisateur connecté et ses clubs
export const userMock = {
    id: 1,
    firstName: 'Mateo',
    clubs: [
        {
            id: 101,
            name: 'Cusco Mountaineering Club',
            city: 'Cusco',
            logo: null, // Can be a URL later
        },
        {
            id: 102,
            name: 'Lima Running Team',
            city: 'Lima',
            logo: null,
        },
    ],
};

const PanelAdmin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selected, setSelected] = useState(0);
    const [drawerOpen, setDrawerOpen] = useState(false);

    // Fix fond body
    useEffect(() => {
        document.body.style.background = '#f5f5f5';
        document.body.style.overflow = 'hidden';
        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.documentElement.style.margin = '0';
        document.documentElement.style.padding = '0';
        document.documentElement.style.background = '#f5f5f5';
        return () => {
            document.body.style.background = '';
            document.body.style.overflow = '';
            document.body.style.margin = '';
            document.body.style.padding = '';
            document.documentElement.style.margin = '';
            document.documentElement.style.padding = '';
            document.documentElement.style.background = '';
        };
    }, []);

    // Sélectionne le menu selon la route
    useEffect(() => {
        let idx = menuItems.findIndex(item => {
            if (item.path === '/admin-panel/events') {
                return location.pathname.startsWith('/admin-panel/events');
            }
            return location.pathname === item.path;
        });
        setSelected(idx === -1 ? 0 : idx);
    }, [location.pathname]);

    const handleLogout = () => {
        localStorage.removeItem('isAdmin');
        navigate('/');
    };

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', height: '100vh', width: '100vw', background: '#f5f5f5', overflow: 'hidden', flexDirection: { xs: 'column', md: 'row' } }}>
            {/* Bouton burger mobile */}
            <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', height: 64, px: 2, background: 'linear-gradient(135deg, #FF6B6B 0%, #E53E3E 100%)', zIndex: 10 }}>
                <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: 'white' }}>
                    <MenuIcon fontSize="large" />
                </IconButton>
                <Typography variant="h6" sx={{ color: 'white', ml: 2, fontWeight: 700 }}>
                    Admin Panel
                </Typography>
            </Box>
            {/* Menu latéral desktop */}
            <Box sx={{
                width: { xs: '100%', md: 260 },
                background: 'linear-gradient(135deg, #FF6B6B 0%, #E53E3E 100%)',
                color: 'white',
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                alignItems: 'stretch',
                py: { xs: 2, md: 4 },
                px: { xs: 1, md: 2 },
                minHeight: { xs: 'auto', md: '100vh' },
                boxShadow: { xs: '0 2px 12px rgba(255,107,107,0.08)', md: '4px 0 24px 0 rgba(255,107,107,0.08)' },
                position: 'relative',
                zIndex: 2,
            }}>
                {/* Profil admin */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, gap: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
                    <Avatar sx={{ width: 56, height: 56, fontWeight: 700, fontSize: 28, bgcolor: '#fff', color: '#FF6B6B', border: '2px solid #FF6B6B' }}>
                        M
                    </Avatar>
                    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                        <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1, color: 'white' }}>
                            Mateo
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)', fontWeight: 500, letterSpacing: 1 }}>
                            Admin Panel
                        </Typography>
                    </Box>
                </Box>
                <List>
                    {menuItems.map((item, idx) => (
                        <ListItem
                            button
                            key={item.label}
                            selected={selected === idx}
                            onClick={() => navigate(item.path)}
                            sx={{
                                borderRadius: 2,
                                mb: 1,
                                background: selected === idx ? 'rgba(255,255,255,0.12)' : 'transparent',
                                color: 'white',
                                fontWeight: selected === idx ? 700 : 500,
                                '&:hover': {
                                    background: 'rgba(255,255,255,0.18)',
                                },
                                transition: 'all 0.2s',
                                justifyContent: { xs: 'center', md: 'flex-start' },
                                px: { xs: 1, md: 2 },
                            }}
                        >
                            <ListItemIcon sx={{ color: 'white', minWidth: 36, display: { xs: 'none', md: 'flex' } }}>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.label} sx={{ textAlign: { xs: 'center', md: 'left' } }} />
                        </ListItem>
                    ))}
                </List>
                <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.18)', display: { xs: 'none', md: 'block' } }} />
                <Button
                    startIcon={<LogoutIcon />}
                    variant="outlined"
                    sx={{
                        color: 'white',
                        borderColor: 'white',
                        borderRadius: 2,
                        fontWeight: 700,
                        textTransform: 'none',
                        '&:hover': {
                            background: 'rgba(255,255,255,0.10)',
                            borderColor: '#fff',
                        },
                        mx: { xs: 'auto', md: 0 },
                        width: { xs: '90%', md: 'auto' },
                        mt: { xs: 2, md: 0 },
                    }}
                    onClick={handleLogout}
                >
                    Logout
                </Button>
            </Box>
            {/* Drawer mobile */}
            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                sx={{ display: { xs: 'block', md: 'none' }, zIndex: 1200 }}
                PaperProps={{
                    sx: {
                        width: 260,
                        background: 'linear-gradient(135deg, #FF6B6B 0%, #E53E3E 100%)',
                        color: 'white',
                        boxShadow: '4px 0 24px 0 rgba(255,107,107,0.18)',
                        py: 4,
                        px: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        minHeight: '100vh',
                    }
                }}
            >
                {/* Profil admin */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, gap: 2, justifyContent: 'flex-start' }}>
                    <Avatar sx={{ width: 56, height: 56, fontWeight: 700, fontSize: 28, bgcolor: '#fff', color: '#FF6B6B', border: '2px solid #FF6B6B' }}>
                        M
                    </Avatar>
                    <Box>
                        <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1, color: 'white' }}>
                            Mateo
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)', fontWeight: 500, letterSpacing: 1 }}>
                            Admin Panel
                        </Typography>
                    </Box>
                </Box>
                <List>
                    {menuItems.map((item, idx) => (
                        <ListItem
                            button
                            key={item.label}
                            selected={selected === idx}
                            onClick={() => { navigate(item.path); setDrawerOpen(false); }}
                            sx={{
                                borderRadius: 2,
                                mb: 1,
                                background: selected === idx ? 'rgba(255,255,255,0.12)' : 'transparent',
                                color: 'white',
                                fontWeight: selected === idx ? 700 : 500,
                                '&:hover': {
                                    background: 'rgba(255,255,255,0.18)',
                                },
                                transition: 'all 0.2s',
                                justifyContent: 'flex-start',
                                px: 2,
                            }}
                        >
                            <ListItemIcon sx={{ color: 'white', minWidth: 36 }}>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.label} />
                        </ListItem>
                    ))}
                </List>
                <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.18)' }} />
                <Button
                    startIcon={<LogoutIcon />}
                    variant="outlined"
                    sx={{
                        color: 'white',
                        borderColor: 'white',
                        borderRadius: 2,
                        fontWeight: 700,
                        textTransform: 'none',
                        '&:hover': {
                            background: 'rgba(255,255,255,0.10)',
                            borderColor: '#fff',
                        },
                        mx: 'auto',
                        width: '90%',
                        mt: 2,
                    }}
                    onClick={handleLogout}
                >
                    Logout
                </Button>
            </Drawer>
            {/* Contenu principal dynamique */}
            <Box sx={{ flex: 1, p: { xs: 1, md: 6 }, display: 'block', height: { xs: 'auto', md: '100vh' }, overflow: 'auto', minWidth: 0 }}>
                <Outlet />
            </Box>
        </Box>
    );
};

export default PanelAdmin; 